import { AlertCircle, Clock, MailX, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type ErrorCode = 'EXPIRED' | 'INVALID' | 'EMAIL_NOT_ALLOWED' | 'NOT_FOUND';

interface ExternalLinkErrorProps {
  errorCode: ErrorCode;
}

const errorMessages = {
  EXPIRED: {
    title: 'Link expirado',
    description:
      'Este link de upload de documentos expirou. Entre em contato com o analista responsável para solicitar um novo link.',
    icon: <Clock className="h-12 w-12 text-orange-500" />,
  },
  EMAIL_NOT_ALLOWED: {
    title: 'Email não autorizado',
    description:
      'O email informado não tem permissão para acessar este link. Verifique se você está usando o email correto ou entre em contato com o analista responsável.',
    icon: <MailX className="h-12 w-12 text-red-500" />,
  },
  INVALID: {
    title: 'Link inválido',
    description:
      'Este link de upload de documentos não é válido. Verifique se você copiou o link corretamente ou entre em contato com o analista responsável.',
    icon: <XCircle className="h-12 w-12 text-red-500" />,
  },
  NOT_FOUND: {
    title: 'Link não encontrado',
    description:
      'Este link de upload de documentos não foi encontrado. Pode ter sido removido ou nunca existiu. Entre em contato com o analista responsável.',
    icon: <AlertCircle className="h-12 w-12 text-gray-500" />,
  },
};

export function ExternalLinkError({ errorCode }: ExternalLinkErrorProps) {
  const error = errorMessages[errorCode];

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="flex min-h-[400px] items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="flex flex-col items-center text-center space-y-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-50">
            {error.icon}
          </div>
          <CardTitle className="text-2xl">{error.title}</CardTitle>
          <CardDescription className="text-base">{error.description}</CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button onClick={handleGoBack} variant="outline">
            Voltar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
